import PageLayoutMain from "./components/PageLayoutMain";

const Turen = () => {
  return <PageLayoutMain />;
};

export default Turen;
